import { PencilEdit01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import React from "react";
import { Children, ReactElement } from "react";
import { Alert, Button, IconButton, Paper, Stack, Typography, useTheme } from "@mui/material";
import useRoutes from "@/hooks/useRoutes";

interface SummaryPanelProps {
    title: string;
    icon: ReactElement;
    stepId?: string;
    error?: string;
    children: ReactElement[] | ReactElement;
    onEdit?: () => void;
}

const SummaryPanel = ({ title, icon, stepId, error, children, onEdit }: SummaryPanelProps) => {
    const [navigate] = useRoutes();
    const { palette } = useTheme();

    const handleEdit = () => {
        if (!stepId) return;
        navigate('organizations.reservations.form', { formId: stepId })
    }
    
    return (
        <Stack spacing={1}>
            <Stack direction="row" spacing={2} justifyContent="space-between" alignItems="center">
                <Stack direction="row" spacing={2} justifyContent="space-between" alignItems="center" >
                    {React.cloneElement(icon, { color: palette.primary.dark })}
                    <Typography variant="h5">{title}</Typography>
                </Stack>
                <div>
                    <IconButton onClick={onEdit ?? handleEdit}><HugeiconsIcon icon={PencilEdit01Icon} color={palette.primary.dark} size={20} /></IconButton>
                </div>
            </Stack>
            <Paper sx={{ p: 2 }}>
                {error ? (
                    <Alert
                        title="Errores"
                        severity="error"
                        action={
                            <Button variant="text" color="inherit" size="small" onClick={onEdit}>Completar</Button>
                        }
                        sx={{
                            marginBottom: 2,
                            alignItems: 'center',
                        }}
                    >
                        {error}
                    </Alert>
                ) : null}
                <Stack spacing={1}>
                    {Children.map(children, child => child)}
                </Stack>
            </Paper>
        </Stack>
    )
}

export default SummaryPanel;
